module.exports = __webpack_public_path__ + "img/wxQrcode.62924ad7.png";